export default {"src":"/_next/static/media/sessionsBooked.91801097.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};